import React, { Component } from 'react';
import Header from './Header';
import Footer from '../../components/Footer/Footer';
import Helmet from 'react-helmet';

class MysteryShopping extends Component {
  render() {
    const styles = require('./MysteryShopping.less');

    return [
      <Helmet
        key="0"
        htmlAttributes={{ lang: 'ru-RU' }}
        title="Mystery Shopping и MVoter – онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{"name": "description", "content": "Mystery Shopping и MVoter – Онлайн платформа для создания моментальной обратной связи с Клиентами! Онлайн сервис по сбору отзывов ✓ Анализ обратной связи от ЦА и потребителей ✓ Управление удовлетворенностью клиентов ✓ Отрасли использования опросника: Рестораны, Банки, Здравоохранение, Торговля, Общественный транспорт ☎ +7 (747) 359-5959"}]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <div className={ styles.header }>
              <h1>Mystery Shopping и MVoter</h1>
              <div className={ styles.headerWrap }>
                <img src="./images/fashion.svg" width="520" height="280" alt="fashion" />
                <p>Одновременная реализация в компаниях исследований Mystery Shopping и внедрение полноценной системы обратной связи с клиентами может давать хороший эффект. Однако надо помнить что Mystery Shopping никак не может заменить систему обратной связи с покупателями и клиентами.<br /><br />Рекомендуем компаниям которые регулярно проводят исследования Mystery Shopping так же внедрить полноценную систему обратной связи MVoter. Почему?</p>
              </div>
            </div>
            <ul className={ styles.steps }>
              <li>
                <h4>Вы будете получать объективные отзывы от ваших настоящих клиентов</h4>
                <p>Соответственно данные системы обратной связи MVoter, всегда будут более валидными и достоверными чем данные службы Mystery Shopping.</p>
              </li>
              <li>
                <h4>Вы будете получать отзывы 24 часа в сутки 365 дней в году</h4>
                <p>Без остановок и перерывов, в то время как Mystery Shopping проводятся лишь несколько дней в году.</p>
              </li>
              <li>
                <h4>В рамках системы обратной связи MVoter вы можете созвониться с вашими реальными клиентами</h4>
                <p>И сможете более подробно услышать их пожелания как улучшить ваш сервис.</p>
              </li>
              <li>
                <h4>Вы существенно экономите</h4>
                <p>Затраты на покупку и внедрение системы обратной связи MVoter значитально дешевле чем стоимость исследований Mystery Shopping.</p>
              </li>
              <li>
                <h4>Автоматические аналитические отчеты об уровне сервиса в нашей компании</h4>
                <p>MVoter очень гибкая система, и может выдавать аналитику как общего плана (глобального и национального масштаба) так и оценку по каждому отдельно взятому отделению или сотруднику.</p>
              </li>
              <li>
                <h4>Регулярная автоматическая рассылка отчетов</h4>
                <p>MVoter будет регулярно и автоматический рассылать аналитические отчеты на email-ы ваших ответственных сотрудников.</p>
              </li>
            </ul>
            <ul className={ styles.steps2 }>
              <li>
                <h4>Вы будете получать объективные отзывы от ваших настоящих клиентов</h4>
                <p>Соответственно данные системы обратной связи MVoter, всегда будут более валидными и достоверными чем данные службы Mystery Shopping.</p>
              </li>
              <li>
                <h4>Вы будете получать отзывы 24 часа в сутки 365 дней в году</h4>
                <p>Без остановок и перерывов, в то время как Mystery Shopping проводятся лишь несколько дней в году.</p>
              </li>
              <li>
                <h4>В рамках системы обратной связи MVoter вы можете созвониться с вашими реальными клиентами</h4>
                <p>И сможете более подробно услышать их пожелания как улучшить ваш сервис.</p>
              </li>
              <li>
                <h4>Вы существенно экономите</h4>
                <p>Затраты на покупку и внедрение системы обратной связи MVoter значитально дешевле чем стоимость исследований Mystery Shopping.</p>
              </li>
              <li>
                <h4>Автоматические аналитические отчеты об уровне сервиса в вашей компании</h4>
                <p>MVoter очень гибкая система, и может выдавать аналитику как общего плана (глобального и национального масштаба) так и оценку по каждому отдельно взятому отделению или сотруднику.</p>
              </li>
              <li>
                <h4>Регулярная автоматическая рассылка отчетов</h4>
                <p>MVoter будет регулярно и автоматический рассылать аналитические отчеты на email-ы ваших ответственных сотрудников.</p>
              </li>
            </ul>
            <div className={ styles.lastStep }>
              <h4>Только верные решения</h4>
              <p>Управленческие решения принимаемые на основе данных системы обратной связи MVoter всегда будут более верными и обоснованными, поскольку опираются исключительно на оригинальные отзывы и рекомендации.</p>
            </div>
            <img src="./images/mystery-shopping.svg" width="940" height="290" alt="mystery"/>
            <h2 style={{ marginTop: '34px' }}>MVoter гарантирует валидность и достоверность данных, и отсутствие возможности фальсификации отзывов.</h2>
          </div>
        </div>
      </div>,
       <Footer key="3" subId="page" />
    ]
  }
}

export default MysteryShopping;
